import { render, staticRenderFns } from "./OrmUtilitiesSideMenu.vue?vue&type=template&id=437fafda&scoped=true"
import script from "./OrmUtilitiesSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmUtilitiesSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437fafda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437fafda')) {
      api.createRecord('437fafda', component.options)
    } else {
      api.reload('437fafda', component.options)
    }
    module.hot.accept("./OrmUtilitiesSideMenu.vue?vue&type=template&id=437fafda&scoped=true", function () {
      api.rerender('437fafda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/utilities/orm/OrmUtilitiesSideMenu.vue"
export default component.exports